import { z } from 'zod';
import { validatedGet, validatedPost, validatedPut, validatedPatch, validatedDelete } from '../api-client.ts';
import { DelegaSchema } from '@/types/entities/index.ts';
import { DelegaArricchitaSchema } from '@/types/api-responses.ts';
import type { CassaCode, MotivoArchiviazione } from '@/types/entities/index.ts';
import { OkResult, buildQueryUrl } from './shared.ts';
import type { PaginatedParams } from './shared.ts';

const DelegheListResult = z.object({
  deleghe: z.array(DelegaArricchitaSchema),
  count: z.number(),
  page: z.number(),
  pageSize: z.number(),
  totalPages: z.number(),
});

const PresentaResult = z.object({
  filePath: z.string(),
  count: z.number(),
  codaId: z.number(),
  accorpata: z.boolean(),
});

interface ListaDelegheParams {
  [key: string]: string | number | undefined;
  page?: number;
  limit?: number;
  sort?: string;
  sortDir?: 'asc' | 'desc';
  q?: string;
  cassa?: string;
  stato?: string;
}

export const delegheApi = {
  lista: (params: ListaDelegheParams = {}) => {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== '') qs.set(k, String(v));
    }
    const url = `deleghe/lista${qs.toString() ? '?' + qs.toString() : ''}`;
    return validatedGet(url, DelegheListResult);
  },

  presentate: (opts?: PaginatedParams) =>
    validatedGet(buildQueryUrl('deleghe/presentate', opts), DelegheListResult),

  daPresentare: (opts?: PaginatedParams) =>
    validatedGet(buildQueryUrl('deleghe/da-presentare', opts), DelegheListResult),

  dettaglio: (id: number) =>
    validatedGet(`deleghe/${id}`, DelegaSchema),

  crea: (dati: { lavoratoreId: number; cassa: CassaCode; dataDecorrenza?: string; operatore?: string; note?: string }) =>
    validatedPost('deleghe', dati, DelegaSchema),

  aggiorna: (id: number, dati: { cassa?: CassaCode; dataDecorrenza?: string | null; operatore?: string | null; note?: string | null }) =>
    validatedPut(`deleghe/${id}`, dati, DelegaSchema),

  presenta: (cassa: CassaCode, dataPresentazione: string, ids?: number[]) =>
    validatedPost('deleghe/presenta', { cassa, dataPresentazione, ...(ids?.length ? { ids } : {}) }, PresentaResult),

  archivia: (id: number, motivo: MotivoArchiviazione, note?: string) =>
    validatedPatch(`deleghe/${id}/archivia`, { motivo, ...(note ? { note } : {}) }, OkResult),

  cambiaStato: (id: number, stato: 'BOZZA' | 'DA_PRESENTARE') =>
    validatedPatch(`deleghe/${id}/stato`, { stato }, OkResult),

  riattiva: (id: number, note: string) =>
    validatedPatch(`deleghe/${id}/riattiva`, { note }, DelegaSchema),

  elimina: (id: number) =>
    validatedDelete(`deleghe/${id}`, OkResult),

};
